import React from 'react';
import ExcelTableColgroup from './Colgroup';
import { observer } from 'mobx-react';
import CardStore from '../../stores/card';
import ExcelTableTBody from './TableTBody';
import { CellProps } from '../../stores/card/ModeExcel';
import _ from 'lodash';
import jQuery from "jquery";
import { Tabs } from 'antd';

export interface ExcelTableTabTableProps {
    cell: CellProps;
    card: CardStore;
}
export interface ExcelTableTabPaneProps {
    tab: {
        key: string;
        tab: string;
        name: string;
    },
    card: CardStore;
}

@observer
export default class ExcelTableTabTable extends React.Component<ExcelTableTabTableProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            showid: '',
        }
    }
    componentDidMount() {
        const tabBar = jQuery(this.refs.tabBar);
        const tab_head = tabBar.parent();
        const tab_top = tab_head.parent();
        const tab_turnleft = tab_top.find(".tab_turnleft");
        const tab_turnright = tab_top.find(".tab_turnright");
        let totalWidth = 0;
        tabBar.children().each(function () {
            totalWidth += jQuery(this).width();
        });
        if (totalWidth > tab_top.width()) {
            tab_top.find(".tab_movebtn").css("display", "block");
            tab_head.width(tab_top.width() - tab_turnleft.width() - tab_turnright.width());
            tabBar.width(totalWidth + 1);
        } else {
            tab_top.find(".tab_movebtn").css("display", "none");
            tab_head.width("100%");
            tabBar.width("100%");
        }
        if (jQuery.browser.chrome) {
            const excelTabTable = jQuery(".excelTabTable");
            _.forEach(excelTabTable, (item, index) => {
                const diff = item.scrollWidth - item.offsetWidth;
                if (diff>0 && diff<3) {
                    excelTabTable.eq(index).css("min-width", "calc(100% - "+diff+"px)");
                }
            })
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // const showid = this.props.showid;
        // if(showid !== prevProps.showid){   //切换了标签显示区域
        //     window.formImgLazyLoad(jQuery(`div#${showid}_content`));    //执行图片懒加载
        // }
        if (jQuery.browser.chrome) {
            const excelTabTable = jQuery(".excelTabTable");
            _.forEach(excelTabTable, (item, index) => {
                const diff = item.scrollWidth - item.offsetWidth;
                if (diff>0 && diff<3) {
                    excelTabTable.eq(index).css("min-width", "calc(100% - "+diff+"px)");
                }
            })
        }
    }



    render() {
        const { cell, card } = this.props;
        const id = `tabarea_${cell.row}_${cell.col}`;
        const wrapClassNames = `cube-tabarea`;
        const tabs = _.get(cell, 'tab.tabs') || [];
        const style = _.get(cell, 'stylejson') || {};
        if (!style)
            return <div>Empty TabArea Style</div>
        const tab = cell.tab;
        let defShowIndex = parseInt(tab.defaultActiveKey || 0);
        if (defShowIndex >= tabs.length)
            defShowIndex = 0;
        const tabShowSymbol = this.state.showid === "" ? tabs[defShowIndex].name : this.state.showid;
        let tabHeadBar = new Array();
        let tabContent = new Array();
        tabs.map((v, k) => {
            const tabid = v.name;
            //拼标签头部bar
            const sel = tabid === tabShowSymbol ? "sel" : "unsel";
            let middleStyle = {
                backgroundImage: "url('" + style[sel + "_bgmiddle"] + "')",
                fontSize: style[sel + "_fontsize"] + "px",
                color: style[sel + "_color"],
                fontFamily: style[sel + "_family"]
            };
            if (style && style[sel + "_bold"] == "1")
                middleStyle["font-weight"] = "bold";
            if (style && style[sel + "_italic"] == "1")
                middleStyle["font-style"] = "italic";
            tabHeadBar.push(
                <div id={tabid} className={"t_" + sel} onClick={this.changeTab.bind(this, tabid)}>
                    <div className={"t_" + sel + "_left norepeat"}
                        style={{
                            backgroundImage: "url('" + style[sel + "_bgleft"] + "')",
                            width: style[sel + "_bgleftwidth"] + "px"
                        }}>
                    </div>
                    <div className={"t_" + sel + "_middle xrepeat lineheight30"} style={middleStyle}>
                        <span>{v.tab}</span>
                    </div>
                    <div className={"t_" + sel + "_right norepeat"}
                        style={{
                            backgroundImage: "url('" + style[sel + "_bgright"] + "')",
                            width: style[sel + "_bgrightwidth"] + "px"
                        }}>
                    </div>
                </div>
            );
            if (k !== tabs.length - 1) {
                tabHeadBar.push(<div className="t_sep norepeat" style={{ width: style.image_sepwidth + "px" }}></div>);
            }
            //拼接标签页内容
            tabContent.push(
                <div className="tab_content" id={tabid + "_content"} style={tabid === tabShowSymbol ? {} : { display: "none" }}>
                    <TabPane tab={v} card={card} />
                </div>
            );
        });
        return (
            <div className={wrapClassNames} id={id} style={{ width: '100%' }} >
                <div className="tab_top">
                    <div className="tab_movebtn tab_turnleft" style={{ display: "none" }} onClick={this.turnBar.bind(this, "left")}></div>
                    <div className="tab_head" style={{ width: "100%" }}>
                        <div className="t_area xrepeat" ref="tabBar"
                            style={{
                                backgroundImage: "url(" + style.image_bg + ")",
                                width: "100%"
                            }}>
                            {tabHeadBar}
                        </div>
                    </div>
                    <div className="tab_movebtn tab_turnright" style={{ display: "none" }} onClick={this.turnBar.bind(this, "right")}></div>
                </div>
                <div className="tab_bottom" style={{ height: tab.height }}>
                    {
                        card.params && card.params.tabLoadAll === '1' ?  tabContent
                        : <Tabs ecId={`${this && this.props && this.props.ecId || ''}_Tabs@50tl3p`} activeKey={tabShowSymbol} >
                        {
                            tabs.map((v, k) => {
                                const tabid = v.name;
                                return <Tabs.TabPane ecId={`${this && this.props && this.props.ecId || ''}_Tabs.TabPane@1305oc@${k}`} key={tabid} >
                                    <div
                                        className="tab_content"
                                        id={tabid + "_content"}
                                    >
                                        <TabPane ecId={`${this && this.props && this.props.ecId || ''}_TabPane@i75ezb@${k}`} tab={v} card={card} />
                                    </div>
                                </Tabs.TabPane>
                            })
                        }
                    </Tabs>
                    }
                </div>
            </div>
        )
    }

    changeTab(selectedTabId) {
        this.setState({ showid: selectedTabId });
    }
    turnBar(flag) {
        const tab_head = jQuery(this.refs.tabBar).parent();
        if (flag === "left")
            tab_head.scrollLeft(tab_head.scrollLeft() - 71);
        else if (flag === "right")
            tab_head.scrollLeft(tab_head.scrollLeft() + 71);
    }
}

@observer
export class TabPane extends React.Component<ExcelTableTabPaneProps, any> {
    render() {
        const { tab, card } = this.props;
        const classNames = 'excelTabTable';
        const excel = card.modeExcel.getTabs(tab.name);//返回了新的modeexcel，但是为初始化
        if (excel) {
            excel.mutilContents = card.modeExcel.mutilContents;//给新modeexcel初始属性
        }
        return (
            excel ? <div style={{ overflowX: "auto", width: "100%" }}>
                <table className={classNames} style={{ width: excel.sumWidth, minWidth: '100%', borderCollapse: 'collapse' }}>
                    <ExcelTableColgroup ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableColgroup@nki1i5`} excel={excel} />
                    <ExcelTableTBody ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTBody@qp33kg`} excel={excel} card={card} form={card.cubeForm} actions={card.Actions} />
                </table>
            </div> : null
        )
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/TabTable.tsx